import { Link } from 'react-router-dom';

interface ProductCardProps {
  id: string;
  name: string;
  slug: string;
  price: number;
  rating: number;
  reviewCount: number;
  image: string;
  features: string[];
  badge?: string;
}

export default function ProductCard({ id, name, slug, price, rating, reviewCount, image, features, badge }: ProductCardProps) {
  return (
    <div className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300">
      <div className="relative aspect-square overflow-hidden">
        <img
          src={image}
          alt={name}
          title={`${name} - 女性情趣用品推荐`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        {badge && (
          <span className="absolute top-3 left-3 bg-accent-500 text-background-50 text-xs font-medium px-2.5 py-1 rounded-full">
            {badge}
          </span>
        )}
      </div>
      <div className="p-4">
        <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 line-clamp-2">
          <Link to={`/product/${slug}`} className="hover:text-primary-600 transition-colors">
            {name}
          </Link>
        </h3>
        <div className="flex items-center gap-1.5 mb-3">
          <div className="flex items-center">
            {[...Array(5)].map((_, i) => (
              <i
                key={i}
                className={`text-xs ${i < Math.floor(rating) ? 'ri-star-fill text-accent-500' : i < rating ? 'ri-star-half-fill text-accent-500' : 'ri-star-fill text-background-300'}`}
              ></i>
            ))}
          </div>
          <span className="text-xs text-foreground-500">({reviewCount})</span>
        </div>
        <div className="flex flex-wrap gap-1.5 mb-3">
          {features.slice(0, 3).map((feature, i) => (
            <span key={i} className="text-xs bg-secondary-100 text-secondary-700 px-2 py-0.5 rounded-full">
              {feature}
            </span>
          ))}
        </div>
        <div className="flex items-center justify-between">
          <span className="text-lg font-semibold text-primary-600">¥{price}</span>
          <Link
            to={`/product/${slug}`}
            className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap"
          >
            查看详情 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </div>
  );
}